import script from "./Basketball.vue?vue&type=script&setup=true&lang=js"
export * from "./Basketball.vue?vue&type=script&setup=true&lang=js"

import "./Basketball.vue?vue&type=style&index=0&id=35a43623&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-35a43623"]])

export default __exports__